import type { Action } from "@circle-workflows/generated/WorkflowsApi.types";
import { get, isString } from "lodash";
import { useFormContext } from "react-hook-form";
import { useIsAiAutomationsV2Enabled } from "../Actions/AiAgents/renamePostTitle/useIsAiAutomationsV2Enabled";
import { getActionHasValue } from "../WorkflowForm/getActionHasValue";
import { hasSomeTruthyValues } from "../WorkflowForm/hasSomeTruthyValues";

export const ACTIONS = "actions";

export const useActionValidation = () => {
  const { watch, formState } = useFormContext();
  const { dirtyFields, touchedFields } = formState;
  const formActions = watch(ACTIONS, []);
  const isAiAutomationsV2Enabled = useIsAiAutomationsV2Enabled();

  const doesActionhasServerId = (action: Action) =>
    isString(action?.id) && !action.id.startsWith("action");

  const areSomeActionsDirty = formActions.some(
    (_action: Action, index: number) => {
      const path = `${ACTIONS}[${index}]`;
      const dirtyInputValue = get(dirtyFields, path, null);
      return hasSomeTruthyValues(dirtyInputValue);
    },
  );

  const areSomeActionsTouched = formActions.some(
    (_action: Action, index: number) => {
      const path = `${ACTIONS}[${index}]`;
      const touchedInputValue = get(touchedFields, path, null);
      return hasSomeTruthyValues(touchedInputValue);
    },
  );

  const areAllActionsFilled = formActions.every((action: Action) =>
    getActionHasValue(action, isAiAutomationsV2Enabled),
  );

  const areAllActionsWithServerIds = formActions.every(
    (action: Action) => isString(action?.id) && !action.id.startsWith("action"),
  );

  const areAllActionsSaved =
    areAllActionsFilled && !areSomeActionsDirty && areAllActionsWithServerIds;

  return {
    doesActionhasServerId,
    areSomeActionsDirty,
    areSomeActionsTouched,
    areAllActionsFilled,
    areAllActionsWithServerIds,
    areAllActionsSaved,
  };
};
